export const useStyles = (theme) => ({
    welcomeContainer: {
        margin: '40px auto',
        [theme.breakpoints.up('sm')]: {
            margin: '80px auto'
        }
    },
    pageTitle: {
        fontSize: '27px',
        [theme.breakpoints.up('sm')]: {
            fontSize: '32px'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '40px'
        }
    },
    subtitle: {
        fontSize: '20px'
    },
    textContent: {
        padding: '10px 0 40px',
        [theme.breakpoints.up('lg')]: {
            fontSize: '20px !important'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '18px !important'
        },
        [theme.breakpoints.up('sm')]: {
            marginLeft: 20,
            width: '80%'
        }
    }
})
